
import { call } from 'redux-saga/effects';

import { ViewCard } from '~src/app/spaces/CardView/ViewCard';
import { Messages } from '~src/codegen/Localize';
import { imgPath } from '~src/common/utilities/ImgUrl';
import { ContentTypeFilterClause,MixedContentItemDefinition, SpaceDefinition } from '~src/contentDefinitionInterfaces/ContentDefinitionsTypes';
import { SpacesSiteUrls } from '~src/spacesPlatform/components/spaceComponents/SpacesSiteUrls';
import { ViewContentType } from '~src/spacesPlatform/models/ContentTypes';
import { IContentInfo } from '~src/spacesPlatform/models/IContentInfo';
import { getViewInfos } from '~src/spacesPlatform/sagas/SpacesSagaHelpers';
import { ServerFilterClauses } from '~src/ts/helpers/ServerFilterClauses';
import { Views } from '~src/views/resources/Views';

import { getGenericDefaultFilters } from './getDefaultFilters';

export const ViewDefinition: MixedContentItemDefinition & SpaceDefinition<'view'> = {
  itemType: 'view',
  contentType: 'view',
  singularName: Messages.view,
  pluralName: Messages.views,
  emptyStateMessage: Messages.viewsEmptyMessage,
  siteFilterByTypeDropdownName: Messages.siteFilterByTypeDropdown_Views,
  contentFilterKeys: ViewContentType.filterKeys,
  defaultFilters: getGenericDefaultFilters,
  cardComponent: ViewCard,
  listViewIconUrl: imgPath('view_18px-large.svg'),
  filterClause: ServerFilterClauses.ContentType(['view']) as ContentTypeFilterClause,
  contentSpaceUrl: (urls: SpacesSiteUrls, contentId: string) => urls.redirectToViewUrl(contentId),
  getBasicQuery: () => {
    return Views.all().withExtraParams(ViewContentType.extraQueryParams);
  },
  fieldValueResourceType: 'view',
  getContentInfo: (contentList: IContentInfo[]) => call(getViewInfos, contentList),
  headerIconPath: undefined,
  supportedDisplayModes: ['list', 'thumbnail'],
};
